import { Mail, Phone } from "lucide-react";
import { Reveal, Label } from "./Motion";
import ChapterMark from "./ChapterMark";
import BookingCalendar from "./BookingCalendar";

const TEAM = [
  {
    name: "Kalib Whaley",
    title: "Founder & CEO",
    subtitle: "",
    email: "kalib@elevaresolutions.me",
    phone: "(260) 200-0907",
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_bbb-boost/artifacts/gsampgbh_kalib%20pic.webp",
    pos: "39% 30%",
  },
  {
    name: "John Caron",
    title: "Co-Founder & Chief Operating Officer",
    subtitle: "",
    email: "john@elevaresolutions.me",
    phone: "(931) 802-3183",
    img: "https://customer-assets-39nsmqrw.emergentagent.net/job_bbb-boost/artifacts/nyagldep_IMG_0142.jpg",
    pos: "50% 40%",
  },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-28 lg:py-40 bg-[#eae7de]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-6">
          <ChapterMark n="06" title="Begin" className="mb-5" />
          <Label>Start Your Business Assessment</Label>
          <h2 className="mt-6 font-head text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-none text-[#1e3d3a]">
            Let&apos;s Find Your<br />Next Opportunity.
          </h2>
          <p className="mt-8 max-w-md text-base lg:text-lg leading-relaxed text-black/65">
            Tell us where your business is today, where you want to go, and what you&apos;re trying to
            improve. We&apos;ll start by understanding the business before recommending a solution.
          </p>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-xl">
            {TEAM.map((p, i) => (
              <div key={i} data-testid={`team-card-${i}`} className="rounded-2xl border border-black/10 bg-white overflow-hidden group shadow-[0_1px_0_rgba(10,10,10,0.03)]">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.name}
                    style={{ objectPosition: p.pos || "50% 50%" }}
                    className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-head text-lg leading-tight text-[#1e3d3a]">{p.name}</h3>
                  <p className="text-xs uppercase tracking-[0.15em] text-[#a3823f] mt-1">{p.title}</p>
                  {p.subtitle && (
                    <p className="text-[11px] uppercase tracking-[0.15em] text-black/50 mt-0.5">{p.subtitle}</p>
                  )}
                  <div className="mt-4 space-y-2">
                    <a data-testid={`team-email-${i}`} href={`mailto:${p.email}`} className="flex items-center gap-2 text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 break-all">
                      <Mail className="h-3.5 w-3.5 text-black/40 shrink-0" /> {p.email}
                    </a>
                    <a data-testid={`team-phone-${i}`} href={`tel:${p.phone.replace(/[^0-9+]/g, "")}`} className="flex items-center gap-2 text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300">
                      <Phone className="h-3.5 w-3.5 text-black/40 shrink-0" /> {p.phone}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7 lg:self-center">
          <BookingCalendar />
        </Reveal>
      </div>
    </section>
  );
}
